export default __webpack_public_path__ + "static/media/loboDeRio.f864c6e5.jpg";